import { gql } from '@apollo/client';

export const FILTERED_INSTITUTION_DISTRICTS = gql`
  query FilteredInstitutionDistricts($input: FilterArgs!) {
    districts: filteredInstitutionDistricts(input: $input) {
      id
      name
    }
  }
`;
